import { MaterialIcon } from 'mol-ui';
import PropTypes from 'prop-types';
import React from 'react';
import { StarWrapper } from './styled';

export const Star = ({ color, disabled, size, type, value }) => {
    const icon = type ? `star_${ type }` : 'star';

    return (
        <StarWrapper disabled={ !!disabled }>
            <MaterialIcon color={ color } icon={ icon } size={ size } />
        </StarWrapper>
    );
};

Star.displayName = 'Star';

Star.defaultProps = {
    disabled: false,
    value: 0
};

Star.propTypes = {
    color: PropTypes.string,
    disabled: PropTypes.bool,
    size: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.number.isRequired
};
